import { Modal } from './Modal';

/**
 * Replacement for the showConfirmModal() helper in the Razor layout - same shared confirmation
 * dialog, driven by props instead of by passing a form element into a global function.
 */
export function ConfirmDialog({
  show,
  title,
  message,
  confirmLabel = 'Confirm',
  confirmClass = 'btn-danger',
  busy = false,
  onConfirm,
  onCancel,
}: {
  show: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  confirmClass?: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Modal
      show={show}
      title={title}
      onClose={onCancel}
      footer={
        <>
          <button type="button" className="btn btn-outline-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className={`btn ${confirmClass}`}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? <span className="spinner-border spinner-border-sm me-1" /> : null}
            {confirmLabel}
          </button>
        </>
      }
    >
      <p className="mb-0 text-start">{message}</p>
    </Modal>
  );
}
